// Common admin form primitives for consistent styling in light + dark
export const Field = ({ label, required, children, className = "" }) => (
    <label className={`block ${className}`}>
        <span className="text-xs uppercase tracking-widest text-stone-muted dark:text-stone-400 block mb-2">
            {label}{required && <span className="text-walnut"> *</span>}
        </span>
        {children}
    </label>
);

export const inputCls =
    "w-full bg-white dark:bg-[#0e0c0a] border border-stone-border dark:border-stone-700 px-3 py-2 text-sm focus:outline-none focus:border-walnut dark:text-stone-100";

export const btnPrimary =
    "inline-flex items-center gap-2 bg-walnut text-cream px-5 py-2.5 text-sm tracking-wider uppercase hover:bg-walnut-dark transition-colors disabled:opacity-60";

export const btnGhost =
    "inline-flex items-center gap-2 border border-stone-border dark:border-stone-700 px-4 py-2 text-sm hover:bg-sand dark:hover:bg-stone-800 transition-colors";

export const btnDanger =
    "inline-flex items-center gap-2 border border-red-200 text-red-700 dark:border-red-900 dark:text-red-300 px-3 py-1.5 text-xs hover:bg-red-50 dark:hover:bg-red-950/40 transition-colors";

export const PageHeader = ({ title, subtitle, action }) => (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
        <div>
            <div className="text-xs uppercase tracking-[0.25em] text-walnut-light mb-2">Admin</div>
            <h1 className="font-serif text-3xl md:text-4xl text-ink dark:text-stone-100">{title}</h1>
            {subtitle && <p className="text-stone-muted dark:text-stone-400 mt-2 text-sm">{subtitle}</p>}
        </div>
        {action}
    </div>
);

export const Card = ({ children, className = "" }) => (
    <div className={`bg-white dark:bg-[#171311] border border-stone-border dark:border-stone-800 ${className}`}>
        {children}
    </div>
);
